import React from 'react'
import { Box } from '@ally/metronome-ui'
import styled from 'styled-components'
import { asCurrency } from '@ally/aos-utils'
import { MonthlyDataSet } from '../../../Data'
import { dataSetColors, LegendTitles } from './SavingsGrowthChart'
import { useWidget } from './WidgetContext'

const Legend = styled.ul`
  margin: 0;
  padding-inline-start: 5px;
`

const LegendMarker = styled.span<{ type: string }>`
  ${({ type }): string =>
    `
      height: 12px;
      width: 12px;
      border-radius: 50%;
      display: inline-block;
      margin-right: 7px;
      background-color: ${dataSetColors[type]}
    `};
`

const ChartLegendItem = styled.li<{ isSummary?: boolean }>`
  ${({ isSummary }): string =>
    `
      list-style: none;
      margin: 0;
      padding: 0;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: space-between;
      align-items: baseline;
      padding: 5px 0;

      ${
        isSummary
          ? `
            display: block;
            flex-basis: 100%;
            text-align: right;
            font-weight: bold;
          `
          : ``
      }
    `};
`
const LegendBox = styled(Box)`
  white-space: nowrap;
`

const SavingsGrowthTable: React.FC = () => {
  const { stkSummaryData } = useWidget()

  return (
    <Legend aria-label="Growth in your savings account for the last month.">
      {stkSummaryData?.growthChart.monthToDateSummary?.dataSets.map(
        (item: MonthlyDataSet) => {
          const [type, amount] = item
          if (amount > 0) {
            return (
              <ChartLegendItem key={type}>
                <LegendBox display="inline-block" textAlign="left" mr="xs">
                  <LegendMarker type={type} />
                  {LegendTitles[type as keyof typeof LegendTitles]}
                </LegendBox>
                <LegendBox display="inline-block" textAlign="right">
                  {asCurrency(amount)}
                </LegendBox>
              </ChartLegendItem>
            )
          }
          return null
        },
      )}
      <ChartLegendItem isSummary>
        Total:{' '}
        {asCurrency(
          stkSummaryData?.growthChart.monthToDateSummary?.aggregateTotal,
        )}
      </ChartLegendItem>
    </Legend>
  )
}

export default SavingsGrowthTable
